// extracted by mini-css-extract-plugin
module.exports = {"viewer":"trinity_viewer__9R8ys"};